import { ListItem } from '../ListItem'
import { RatingListItemContent } from '../RatingListItemContent'

function RatingListItem(props) {
  return <ListItem {...props} Content={RatingListItemContent} />
}

export default RatingListItem
